import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=efd64998&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=efd64998&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd64998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd64998')) {
      api.createRecord('efd64998', component.options)
    } else {
      api.reload('efd64998', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=efd64998&scoped=true", function () {
      api.rerender('efd64998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/DL/BaseInfo.vue"
export default component.exports